import { serialize } from '@/@core/libs/serialize/util'
import HttpAgency from './httpAgency'

// Shows
export const podcastShowsList = (params = '') => HttpAgency.get(`/podcast-shows${serialize(params)}`)
export const podcastShowByID = (id) => HttpAgency.get(`/podcast-shows/${id}`)
export const newPodcastShow = (params) => HttpAgency.post(`/podcast-shows`, params)
export const updatePodcastShow = (params) => HttpAgency.put(`/podcast-shows/${params.id}`, params)
export const deletePodcastShow = (id) => HttpAgency.delete(`/podcast-shows/${id}`)

// Episodes
export const podcastEpisodesList = (params = '') => HttpAgency.get(`/podcast-episodes${serialize(params)}`)
export const podcastEpisodeByID = (id) => HttpAgency.get(`/podcast-episodes/${id}`)
export const newPodcastEpisode = (params) => HttpAgency.post(`/podcast-episodes`, params)
export const updatePodcastEpisode = (params) => HttpAgency.put(`/podcast-episodes/${params.id}`, params)
export const deletePodcastEpisode = (id) => HttpAgency.delete(`/podcast-episodes/${id}`)
export const transitionPodcastEpisode = (id, status) => HttpAgency.post(`/podcast-episodes/${id}/transition`, { status })
// MP3 hosting: the file is streamed to the uploads bucket (MinIO); no timeout, episodes are ~75 MB
export const uploadPodcastEpisodeAudio = (id, formData, onUploadProgress) => HttpAgency.post(`/podcast-episodes/${id}/audio`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 0, onUploadProgress })
export const deletePodcastEpisodeAudio = (id) => HttpAgency.delete(`/podcast-episodes/${id}/audio`)
// Editorial gate: only approved audio is served in the RSS feed
export const approvePodcastEpisodeAudio = (id) => HttpAgency.post(`/podcast-episodes/${id}/audio/approve`)
export const unapprovePodcastEpisodeAudio = (id) => HttpAgency.delete(`/podcast-episodes/${id}/audio/approve`)
export const podcastEpisodeInsights = (params = '') => HttpAgency.get(`/podcast-episodes/insights${serialize(params)}`)

// Guests
export const podcastGuestsList = (params = '') => HttpAgency.get(`/podcast-guests${serialize(params)}`)
export const podcastGuestByID = (id) => HttpAgency.get(`/podcast-guests/${id}`)
export const newPodcastGuest = (params) => HttpAgency.post(`/podcast-guests`, params)
export const updatePodcastGuest = (params) => HttpAgency.put(`/podcast-guests/${params.id}`, params)
export const deletePodcastGuest = (id) => HttpAgency.delete(`/podcast-guests/${id}`)
export const invitePodcastGuest = (id, locale = 'pt-BR') => HttpAgency.post(`/podcast-guests/${id}/invite`, { locale })
export const updatePodcastGuestStatus = (id, status) => HttpAgency.patch(`/podcast-guests/${id}/status`, { status })
export const cancelPodcastGuestSlot = (id) => HttpAgency.post(`/podcast-guests/${id}/cancel`)
export const reschedulePodcastGuestSlot = (id, slotId) => HttpAgency.post(`/podcast-guests/${id}/reschedule`, { podcast_recording_slot_id: slotId })
export const sendPodcastGuestConsent = (id, locale = 'pt-BR') => HttpAgency.post(`/podcast-guests/${id}/send-consent`, { locale })
export const sendPodcastGuestThankYou = (id) => HttpAgency.post(`/podcast-guests/${id}/send-thank-you`)
export const uploadPodcastGuestPhotos = (id, formData) => HttpAgency.post(`/podcast-guests/${id}/photos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
export const deletePodcastGuestPhoto = (id, photoUrl) => HttpAgency.delete(`/podcast-guests/${id}/photos`, { data: { photo_url: photoUrl } })

// Calendar
export const podcastEpisodesCalendar = (params = '') => HttpAgency.get(`/podcast-episodes/calendar${serialize(params)}`)

// Hosts
export const podcastHostsList = (params = '') => HttpAgency.get(`/podcast-hosts${serialize(params)}`)
export const podcastHostByID = (id) => HttpAgency.get(`/podcast-hosts/${id}`)
export const newPodcastHost = (params) => HttpAgency.post(`/podcast-hosts`, params)
export const updatePodcastHost = (params) => HttpAgency.put(`/podcast-hosts/${params.id}`, params)
export const deletePodcastHost = (id) => HttpAgency.delete(`/podcast-hosts/${id}`)

// Sponsor Slots
export const podcastSponsorsList = (params = '') => HttpAgency.get(`/podcast-sponsor-slots${serialize(params)}`)
export const podcastSponsorByID = (id) => HttpAgency.get(`/podcast-sponsor-slots/${id}`)
export const newPodcastSponsor = (params) => HttpAgency.post(`/podcast-sponsor-slots`, params)
export const updatePodcastSponsor = (params) => HttpAgency.put(`/podcast-sponsor-slots/${params.id}`, params)
export const deletePodcastSponsor = (id) => HttpAgency.delete(`/podcast-sponsor-slots/${id}`)

// Recording Slots
export const podcastRecordingSlotsList = (params = '') => HttpAgency.get(`/podcast-recording-slots${serialize(params)}`)
export const podcastRecordingSlotGuests = (id) => HttpAgency.get(`/podcast-recording-slots/${id}/guests`)
export const newPodcastRecordingSlot = (params) => HttpAgency.post(`/podcast-recording-slots`, params)
export const updatePodcastRecordingSlot = (params) => HttpAgency.put(`/podcast-recording-slots/${params.id}`, params)
export const deletePodcastRecordingSlot = (id) => HttpAgency.delete(`/podcast-recording-slots/${id}`)
export const generatePodcastRecordingSlots = (params) => HttpAgency.post(`/podcast-recording-slots/generate`, params)

// Digital Consents
export const digitalConsentsList = (params = '') => HttpAgency.get(`/digital-consents${serialize(params)}`)
export const digitalConsentByID = (id) => HttpAgency.get(`/digital-consents/${id}`)
export const revokeDigitalConsent = (id, reason) => HttpAgency.post(`/digital-consents/${id}/revoke`, { reason })
